export default __webpack_public_path__ + "static/collect-tips-graphic-c70968102b895e08771bed358e8e9ecf.svg";